import { convertToSentenceCase } from '../../../shared/utils/convert-to-sentence-case/convert-to-sentence-case.util';
import { ItemLabelModel } from '../../shared/components/dropdown/models/dropdown-props.model';
import { mapFileMetadataDtoToFileMetadataModel } from '../../shared/utils/mapping/mapping.utils';
import { WebGameOrientationEnum } from '../components/game-form-container/enums/web-game-orientation.enum';
import { WebGameRequestDto } from '../dtos/web-game-request.dto';
import { WebGameResponseDto } from '../dtos/web-game-response.dto';
import { WebGameRequestModel } from '../models/web-game-request.model';
import { WebGameResponseModel } from '../models/web-game-response.model';

export const mapWebGameRequestModelToWebGameRequestDto = (
  game: WebGameRequestModel
): WebGameRequestDto => ({
  id: game.id,
  genre: game.genre,
  size: game.size,
  orientation: game.orientation,
  thumbnailFileId: game.thumbnailFileId,
  title: game.title,
  zipFileId: game.zipFileId,
});

export const mapWebGameResponseDtoToWebGameResponseModel = (
  game: WebGameResponseDto
): WebGameResponseModel => ({
  id: game.id,
  genre: game.genre,
  size: game.size,
  orientation: game.orientation,
  thumbnail: mapFileMetadataDtoToFileMetadataModel(game.thumbnail),
  title: game.title,
  zip: mapFileMetadataDtoToFileMetadataModel(game.zip),
});

export function mapWebGameOrientationEnumToItemLabelModel(
  orientation: WebGameOrientationEnum
): ItemLabelModel {
  return {
    id: Object.keys(WebGameOrientationEnum).indexOf(orientation),
    label: convertToSentenceCase(WebGameOrientationEnum[orientation]),
  };
}
